var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Appbar'),_c('NavigationDrawer'),_c('v-content',[_c('v-fade-transition',[_c('router-view',{staticClass:"content"})],1)],1),_c('ErrorAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }